export default __webpack_public_path__ + "static/media/banner2.37bc81a9.jpg";